import { render, staticRenderFns } from "./update-general.vue?vue&type=template&id=21ef201e&scoped=true&"
import script from "./update-general.vue?vue&type=script&lang=js&"
export * from "./update-general.vue?vue&type=script&lang=js&"
import style0 from "./update-general.vue?vue&type=style&index=0&id=21ef201e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ef201e",
  null
  
)

export default component.exports